import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { from } from 'rxjs';
import { DocumentEditorType } from '@pt/pt-models';
import { DocResourceStatus } from 'it/primatoo/openapi/api/org/schemas/common/DocResourceStatus';
import {
  DocumentActionDialogComponent
} from '../dialogs/publish-reopen-document-dialog/document-action-dialog.component';

const md = '500px';
const xl = 'xl';

@Injectable({
  providedIn: 'root'
})
export class EditorDocumentsDialogService {

  constructor(private modalService: NgbModal) {
  }

  runPublishDocumentDialog = (docType: DocumentEditorType, docId: number, docStatus: DocResourceStatus) => {
    const modalRef = this.modalService.open(DocumentActionDialogComponent, {
      centered: true,
      backdrop: 'static',
      size: md
    });
    modalRef.componentInstance.run(docType, docId, docStatus, 'PUBLISH');
    return from(modalRef.result);
  };

  runReopenDocumentDialog = (docType: DocumentEditorType, docId: number, docStatus: DocResourceStatus) => {
    const modalRef = this.modalService.open(DocumentActionDialogComponent, {
      centered: true,
      backdrop: 'static',
      size: md
    });
    modalRef.componentInstance.run(docType, docId, docStatus, 'REOPEN');
    return from(modalRef.result);
  };

  runValidateDocumentDialog = (docType: DocumentEditorType, docId: number, docStatus: DocResourceStatus) => {
    const modalRef = this.modalService.open(DocumentActionDialogComponent, {
      centered: true,
      backdrop: 'static',
      size: md
    });
    modalRef.componentInstance.run(docType, docId, docStatus, 'VALIDATE');
    return from(modalRef.result);
  };

}
